import {Col, Row} from "antd";
import moment from "moment";
import {t} from "i18next";
import ApiService from "../../../core/service/api-service";
import {info} from "./info";
import {CountBarChart, DailyBarChart, dailySummary, modalitySlot, PanelSpin, percent, studyTypeLabel, studyTypeSlot, Tile, usePanelData} from "./PanelParts";

const fetchMine = (filter) => ApiService.Dashboard.MyReads(filter)

/**
 * Doktor panosu: okunan çekim (İstatistikler sekmesiyle aynı tanım — okuyanı bu doktor olan onaylı
 * raporlar). fetcher verilmezse kullanıcının kendi verisi; yönetici Panom'da seçtiği kullanıcınınkini verir.
 */
export default function DoctorPanel({filter, fetcher = fetchMine}) {
    const {data, loading} = usePanelData(fetcher, filter)
    const summary = dailySummary(data?.daily)
    const re = data?.reAssessment

    return (
        <PanelSpin loading={loading}>
            <Row gutter={[12, 12]}>
                <Col xs={12} md={6}>
                    <Tile title={t('Read studies')} value={data?.total} info={info('readStudies')}/>
                </Col>
                <Col xs={12} md={6}>
                    <Tile title={t('Emergency')} value={data?.emergencyTotal} hint={percent(data?.emergencyTotal, data?.total)} info={info('emergency')}/>
                </Col>
                <Col xs={12} md={6}>
                    <Tile title={t('Daily average')} value={summary.average} info={info('dailyAverage')}/>
                </Col>
                <Col xs={12} md={6}>
                    <Tile
                        title={t('Busiest day')}
                        info={info('busiestDay')}
                        value={summary.busiest?.count}
                        hint={summary.busiest ? moment(summary.busiest.day).format('DD.MM.YYYY dddd') : null}
                    />
                </Col>

                <Col xs={24}>
                    <DailyBarChart title={t('Read studies by day')} info={info('readByDay')} daily={data?.daily}/>
                </Col>

                <Col xs={24} md={12}>
                    <CountBarChart title={t('By modality')} info={info('byModality')} items={data?.modalities} slotOf={modalitySlot}/>
                </Col>
                <Col xs={24} md={12}>
                    <CountBarChart title={t('By study type')} info={info('byStudyType')} items={data?.studyTypes} labelOf={x => studyTypeLabel(x.id)} slotOf={studyTypeSlot}/>
                </Col>

                <Col xs={12} md={6}>
                    <Tile title={t('Re-assessment requests')} value={re?.total} info={info('reAssessment')}/>
                </Col>
                <Col xs={12} md={6}>
                    <Tile title={t('Report changed')} value={re?.changed} info={info('reChanged')}/>
                </Col>
                <Col xs={12} md={6}>
                    <Tile title={t('Report unchanged')} value={re?.unchanged} info={info('reUnchanged')}/>
                </Col>
                <Col xs={12} md={6}>
                    <Tile title={t('Still open')} value={re?.open} info={info('reOpen')}/>
                </Col>
            </Row>
        </PanelSpin>
    )
}
